module.exports = __webpack_public_path__ + "static/media/MS.d0bb886c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MS.svg
// module id = 2214
// module chunks = 7